import { lazy } from 'react'

export const Layout = lazy(
  () => import('src/features/layout/components/Layout/Layout')
)

export const SignInPage = lazy(() =>
  import('src/features/auth/components/SignInPage').then((m) => ({
    default: m.SignInPage
  }))
)
export const OidcCallbackPage = lazy(() =>
  import('src/features/auth/components/OidcCallbackPage').then((m) => ({
    default: m.OidcCallbackPage
  }))
)
export const HomePage = lazy(() => import('src/features/home/pages/HomePage'))
export const ProfilePage = lazy(
  () => import('src/features/profile/pages/ProfilePage')
)
export const PeoplePage = lazy(() => import('src/features/people/pages/People'))
export const PersonDetailPage = lazy(
  () => import('src/features/people/pages/PersonDetailPage')
)
export const OrgStructurePage = lazy(
  () => import('src/features/people/pages/OrgStructurePage')
)
export const PeopleSpotlightsPage = lazy(
  () => import('src/features/people/pages/PeopleSpotlightsPage')
)
export const PeopleSpotlightDetailsPage = lazy(
  () => import('src/features/people/pages/PeopleSpotlightDetailsPage')
)
export const PeopleUpdatesPage = lazy(
  () => import('src/features/people-updates/pages/PeopleUpdatesPage')
)
export const NewsPage = lazy(() => import('src/features/news/pages/NewsPage'))
export const NewsDetailsPage = lazy(
  () => import('src/features/news/pages/NewsDetailsPage')
)
export const PoliciesPage = lazy(
  () => import('src/features/policies/pages/PoliciesPage')
)
export const BenefitsPage = lazy(
  () => import('src/features/benefits/pages/BenefitsPage')
)
export const DaysOffPage = lazy(
  () => import('src/features/days-off/pages/DaysOffPage')
)
export const WorkingHoursPage = lazy(
  () => import('src/features/days-off/pages/WorkingHoursPage')
)
export const ResourcesPage = lazy(
  () => import('src/features/resources/pages/ResourcesPage')
)
export const ResourcesPageDetails = lazy(
  () => import('src/features/resources/pages/ResourcesPageDetails')
)
export const OnBoardingPage = lazy(
  () => import('src/features/onboarding/pages/OnBoardingPage')
)
export const OnBoardingDetailsPage = lazy(
  () => import('src/features/onboarding/pages/OnBoardingDetailsPage')
)
export const NewslettersPage = lazy(
  () => import('src/features/newsletters/pages/NewslettersPage')
)
export const NewsletterDetailsPage = lazy(
  () => import('src/features/newsletters/pages/NewsletterDetailsPage')
)
export const NotificationsPage = lazy(
  () => import('src/features/notifications/pages/NotificationsPage')
)
export const NotificationRedirectPage = lazy(
  () => import('src/features/notifications/pages/NotificationRedirectPage')
)
export const NotFoundPage = lazy(
  () => import('src/features/not-found/pages/NotFoundPage')
)
export const KudosFeedPage = lazy(
  () => import('src/features/kudos/pages/KudosFeedPage')
)
export const KudosDetailPage = lazy(
  () => import('src/features/kudos/pages/KudosDetailPage')
)
